<template>
  <div id="videoDetail">
    <div class="container" :style="'height:' + height + 'px'">
      <img v-if="imgShow" class="cover_img" :src="videoInfo.v_cover_img" alt="">
      <video
        class="video"
        :src="videoInfo.v_src"
        ref="myVideo"
        autoplay="true"
        @click="changePlay"
      >
        <source :src="videoInfo.v_src" type="video/mp4" />
        您的浏览器不支持Video标签。
      </video>
      <img
        class="play"
        src="../../assets/qcwy/images/play.png"
        v-if="!isPlay"
        @click="changePlay"
        alt=""
      />
      <div class="operation">
        <div class="operation-item">
          <div class="img-bg">
            <img src="../../assets/qcwy/images/chakan.png" alt="" />
          </div>
          <p>{{ videoInfo.v_read_num }}</p>
        </div>
        <div class="operation-item">
          <div class="img-bg" @click="thumbUp">
            <img
              v-if="isThumb"
              src="../../assets/qcwy/images/thumb2.png"
              alt=""
            />
            <img v-else src="../../assets/qcwy/images/thumb1.png" alt="" />
          </div>
          <p>{{ videoInfo.v_thumb_num }}</p>
        </div>
        <div class="operation-item">
          <div class="img-bg" @click="share(isShowMask)">
            <img
              class="share"
              src="../../assets/qcwy/images/share.png"
              alt=""
            />
          </div>
          <p>{{ videoInfo.v_share_num }}</p>
        </div>
      </div>
      <div class="desc">
        <div class="desc-bg">
          <div class="desc-content">
            <p>
              {{ desc
              }}<span v-if="showDesc">【{{ isShow ? "收起" : "展开" }}】</span>
            </p>
            <div class="link" v-if="videoInfo.is_link == 1">
              <p>相关推荐：</p>
              <div
                class="btn"
                v-if="videoInfo.link_type == 1"
                @click="
                  toMini(
                    videoInfo.link_url,
                    videoInfo.is_link_location,
                    videoInfo.link_app_id
                  )
                "
              >
                <p>{{ videoInfo.link_title }}</p>
              </div>
              <div
                class="btn"
                v-else-if="videoInfo.link_type == 2"
                @click="toLink(videoInfo.link_url)"
              >
                <p>{{ videoInfo.link_title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mask" v-if="isShowMask" @click="share(isShowMask)">
        <img class="text" src="../../assets/qcwy/images/text.png" alt="" />
        <img class="arrow" src="../../assets/qcwy/images/arrow.png" alt="" />
        <img class="tip" src="../../assets/qcwy/images/tip.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import { api, qcwyAPI } from "../../api/qcwy";
import jssdkAPI from "../../api/JSSDK";
import wechatAPI from "../../api/weChatOfficialAcount";
import { Toast } from "vant";
export default {
  name: "videoDetail",
  data() {
    return {
      height:
        `${document.documentElement.clientHeight}` > 1000
          ? 1000
          : `${document.documentElement.clientHeight}`,
      desc: "",
      allDesc: "",
      videoInfo: {},
      user_id: "",
      v_id: "",
      isThumb: false,
      showDesc: true,
      isShow: true,
      isPlay: false,
      isShowMask: false,
      imgShow:true,
    };
  },
  beforeCreate() {
    sensors.registerPage({
      platform_type: "利北小程序",
    });
    sensors.quick("autoTrack");
  },
  async created() {
    await this.getWindowsURL();
    await this.wxConfig();
  },
  mounted() {
    this.isThumbUp();
    this.addReadRecord();
    this.setAutoPlay();
  },
  methods: {
    //微信公众号js配置文件
    wxConfig() {
      this.$axios
        .get(jssdkAPI.jssdk.signature, {
          params: { url: window.location.href.split("#")[0] },
        })
        .then((res) => {
          console.log(res);
          wx.config({
            debug: false,
            appId: "wx6c8bdb72dba32bd2", //后台获取
            timestamp: res.data.timestamp, //后台获取
            nonceStr: res.data.noncestr, //后台获取
            signature: res.data.signature, //后台获取
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareAppMessage",
              "invokeMiniProgramAPI",
            ],
            openTagList: ["wx-open-launch-weapp"],
          });
          wx.ready(function () {});
        })
        .catch((res) => {
          console.log(res);
        });
    },
    /**
     * 获取小程序传参
     */
    getWindowsURL() {
      let url = decodeURIComponent(window.location.href);
      let params = url.split("?")[1];
      this.v_id = params.split("&")[0].split("=")[1];
      this.user_id = params.split("&")[1].split("=")[1];
      this.getVideoInfo();
    },

    /**
     * 设置视频自动播放
     */
    setAutoPlay() {
      this.$refs.myVideo.autoplay = true;
      this.$refs.myVideo.load();
    },
    /**
     * 视频的播放和暂停
     */
    changePlay() {
      if (this.$refs.myVideo.paused) {
        this.$refs.myVideo.play();
        this.isPlay = true;
        this.imgShow = false;
        sensors.track("PlayButtonClick", {
          playbutton_click: true,
        });
      } else {
        this.$refs.myVideo.pause();
        this.isPlay = false;
        sensors.track("PlayButtonClick", {
          playbutton_click: false,
        });
      }
    },
    /**
     * 截取字符串
     */
    substr() {
      this.desc =
        this.allDesc.length > 68
          ? this.allDesc.substring(0, 68) + "..."
          : this.allDesc;
      this.showDesc = this.allDesc.length > 68 ? true : false;
    },

    /**
     * 获取视频详情
     * @param int $v_id 视频id
     */
    getVideoInfo() {
      let data = {
        v_id: this.v_id,
      };
      this.$axios.get(qcwyAPI.videoInfo, { params: data }).then((res) => {
        if (res.data.statusCode == 1000) {
          this.videoInfo = res.data.data;
          this.allDesc = res.data.data.v_desc;
          this.substr();
        }
      });
    },

    /**
     * 点赞
     * @param int v_id
     * @param int user_id
     */
    thumbUp() {
      this.isThumb = !this.isThumb;
      this.videoInfo.v_thumb_num = this.isThumb
        ? this.videoInfo.v_thumb_num + 1
        : this.videoInfo.v_thumb_num - 1;
      if (this.isThumb) {
        Toast.success("点赞成功");
        sensors.track("LikeButtonClick", {
          like_click: true,
        });
      } else {
        sensors.track("LikeButtonClick", {
          like_click: false,
        });
      }
      let data = {
        status: this.isThumb,
        v_id: this.v_id,
        user_id: this.user_id,
      };
      this.$axios.get(qcwyAPI.thumbUp, { params: data }).then((res) => {
        console.log(res);
      });
    },

    /**
     * 判断是否点赞
     * @param int v_id
     * @param int user_id
     */
    isThumbUp() {
      let data = {
        v_id: this.v_id,
        user_id: this.user_id,
      };
      this.$axios.get(qcwyAPI.isThumbUp, { params: data }).then((res) => {
        console.log(res);
        if (res.data.statusCode == 1000) {
          this.isThumb = false;
        } else {
          this.isThumb = true;
        }
      });
    },
    share(isShowMask) {
      this.isShowMask = !isShowMask;
      let data = {
        v_id: this.v_id,
      };
      if (this.isShowMask) {
        sensors.track("ShareButtonClick", {
          share_click: true,
        });
        this.$axios
          .get(qcwyAPI.addShareRecord, { params: data })
          .then((res) => {
            this.videoInfo.v_share_num++;
          });
      }
    },
    /**
     * 增加观看记录
     * @param int v_id
     */
    addReadRecord() {
      let data = {
        v_id: this.v_id,
        user_id: this.user_id,
      };
      this.$axios.get(qcwyAPI.addReadRecord, { params: data }).then((res) => {
        console.log(res);
        this.videoInfo.v_read_num++;
      });
    },

    toMini(linkUrl, isLocation, appId) {
      if (isLocation == 1) {
        sensors.track("RelevantLinkClick", {
          video_title: this.videoInfo.v_title,
          type: "利北小程序",
          path: linkUrl,
        });
        wx.miniProgram.navigateTo({ url: linkUrl });
      } else {
        sensors.track("RelevantLinkClick", {
          video_title: this.videoInfo.v_title,
          type: "其他小程序",
          path: linkUrl,
        });
        wx.miniProgram.navigateTo({
          url:
            "/pages/worriless/informa/jumpto?appId=" +
            appId +
            "&path=" +
            linkUrl,
        });
      }
    },
    /**
     * 跳转页面
     * @param String linkSrc
     */
    toLink(linkSrc) {
      sensors.track("RelevantLinkClick", {
        video_title: this.videoInfo.v_title,
        type: "公众号发文",
        path: linkSrc,
      });
      window.location.replace(linkSrc);
    },
  },
};
</script>
<style scoped>
.container {
  position: relative;
  display: flex;
  align-items: center;
  width: 7.5rem;
  background-color: rgba(0, 0, 0);
}
.cover_img {
  position: absolute;
  width: 7.5rem;
  height: auto;
}
.video {
  width: 7.5rem;
  height: auto;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.play {
  position: absolute;
  top: 44%;
  left: 44%;
  width: 1.5rem;
  height: 1.5rem;
}
.operation {
  position: absolute;
  right: 0.3rem;
  bottom: 2.19rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 0.8rem;
  height: 4rem;
}
.operation .operation-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 0.8rem;
  height: 1.2rem;
}
.operation .operation-item .img-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.6);
}
.operation .operation-item .img-bg img {
  width: 0.45rem;
  height: 0.33rem;
}
.operation .operation-item .img-bg .share {
  width: 0.42rem;
  height: 0.44rem;
}
.operation .operation-item p {
  font-size: 0.2rem;
    color: #fff;
    background: rgba(0,0,0,.5);
    border-radius: 10px;
    width: 29px;
    text-align: center;
}
.desc {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 7.5rem;
  height: 1.8rem;
  /* animation: desc 100ms linear 0s 1 forwards; */
}
/* @keyframes desc{
  0% {position: absolute;left: 0;bottom: 0;width: 7.5rem;height: 1.8rem;}
  100% {position: absolute;left: 0;top: 0;width: 7.5rem;height: 100%;}
} */
.desc .desc-bg {
  width: 7.5rem;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}
.desc .desc-bg .desc-content {
  width: 6.65rem;
  height: 2.3rem;
}
.desc .desc-bg .desc-content p {
  word-break: break-all;
  width: 6.65rem;
  font-size: 0.24rem;
  color: white;
}
.desc .desc-bg .desc-content p span {
  font-size: 0.24rem;
  color: #fccc00;
}
.desc .desc-bg .desc-content .link {
  display: flex;
  align-items: center;
  margin-top: 0.1rem;
}
.desc .desc-bg .desc-content .link p {
  width: auto;
}
.btn {
  width: 2.85rem;
  height: 0.45rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  background: linear-gradient(#ffae00, #f5881e);
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}
.mask .text {
  position: fixed;
  right: 1.53rem;
  top: 0rem;
  width: 1.42rem;
  height: 0.34rem;
}
.mask .arrow {
  position: fixed;
  right: 1rem;
  top: 0.34rem;
  width: 2.74rem;
  height: 3.43rem;
}
.mask .tip {
  position: fixed;
  right: 2rem;
  top: 3.77rem;
  width: 3.51rem;
  height: 2.35rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/qcwy/videoDetail.vue